import { EVENT_NAME_CONTRACT_PURCHASE_VIEWED } from 'src/app/analytics';

export const getProductIds = (
  productId: string | number,
  jobAdTypePosted: string,
  adBudgetPurchased: string,
): string[] => {
  const productIds = [`jobAd${productId}`];

  if (adBudgetPurchased === EVENT_NAME_CONTRACT_PURCHASE_VIEWED) {
    if (jobAdTypePosted.toLowerCase() === 'standout') {
      productIds.push('contractStandout');
    }

    if (jobAdTypePosted.toLowerCase() === 'classic') {
      productIds.push('contractClassic');
    }
  }
  return productIds;
};
